import React from 'react';
import { Box } from '@mui/material';
import Dots4x15Graphic from '../graphics/Dots4x15Graphic';
import Dots4x122Graphic from '../graphics/Dots4x122Graphic';
import GreenGradientCircleGraphic from '../graphics/GreenGradientCircleGraphic';
import CircleOneGraphic from '../graphics/CircleOneGraphic';
import CircleTwoGraphic from '../graphics/CircleTwoGraphic';
import Dots2x11Graphic from '../graphics/Dots2x11Graphic';

const DotsAndCirlcesProfile = () => (
  <Box sx={{
    height: '100%',
    width: '100%',
  }}
  >
    <Dots4x15Graphic // Dots slidin up on the right edge
      sx={{
        bottom: '5%',
        position: 'absolute',
        right: 0,
        animation: 'heroBttDotsBlue4x15Graphic 4s ease-in-out',
        '@keyframes heroBttDotsBlue4x15Graphic': {
          from: {
            bottom: '-50%',
          },
          to: {
            bottom: '5%',
          },
        },
      }}
    />

    <CircleTwoGraphic // Purple Circle sliding right to left
      sx={{
        bottom: '8%',
        position: 'absolute',
        right: '10%',
        width: 'max-content',
        animation: 'heroLtrPurpleCircleGraphic 2.5s ease-in-out',
        '@keyframes heroLtrPurpleCircleGraphic': {
          from: {
            right: '0',
          },
          to: {
            right: '10%',
          },
        },
      }}
    />

    <CircleOneGraphic // Yellow Circle sliding right to left
      sx={{
        bottom: '11%',
        position: 'absolute',
        right: '46%',
        animation: 'heroLtrYellowCircleGraphic 4s ease-in-out',
        '@keyframes heroLtrYellowCircleGraphic': {
          from: {
            right: '0',
          },
          to: {
            right: '46%',
          },
        },
      }}
    />

    <GreenGradientCircleGraphic
      sx={{
        bottom: '8%',
        position: 'absolute',
        right: '26%',
        width: 'max-content',
        animation: 'heroLtrGreenGradientCircleGraphic 1.5s ease-in-out',
        '@keyframes heroLtrGreenGradientCircleGraphic': {
          from: {
            right: '0',
          },
          to: {
            right: '26%',
          },
        },
      }}
    />

    <Dots4x122Graphic // Dots sliding right to left from right edge
      sx={{
        bottom: '7%',
        position: 'absolute',
        right: '-38px',
        width: 'max-content',
        animation: 'heroLtrDots4x122Graphic 1s ease-in',
        '@keyframes heroLtrDots4x122Graphic': {
          from: {
            right: '-450px',
          },
          to: {
            right: '0',
          },
        },
      }}
    />

    <Dots2x11Graphic // Dots sliding top to bottom on the left edge
      sx={{
        position: 'absolute',
        width: 'max-content',
        animation: 'heroTtbDots2x11Graphic 5s ease-in-out',
        '@keyframes heroTtbDots2x11Graphic': {
          from: {
            top: '-100%',
          },
          to: {
            top: '0',
          },
        },
      }}
    />
  </Box>
);

export default DotsAndCirlcesProfile;
